import { Controller } from 'stimulus';

// E3 Layer 2: progressive enhancement only. The server-rendered featured-doctors
// strip already sits in the DOM (what crawlers/no-JS visitors see); this swaps it
// for nearest-doctor cards once the browser hands us real coordinates. Any failure
// (no geolocation support, permission denied, timeout, fetch error) just leaves
// the SSR content in place.
export default class extends Controller {
  connect() {
    if (!('geolocation' in navigator)) return;

    navigator.geolocation.getCurrentPosition(
      (position) => this.loadNearby(position.coords.latitude, position.coords.longitude),
      () => {},
      { timeout: 5000, maximumAge: 600000 }
    );
  }

  loadNearby(lat, lng) {
    const url = this.element.dataset.url;
    if (!url) return;

    fetch(`${url}?lat=${lat}&lng=${lng}`, { headers: { Accept: 'application/json' } })
      .then((response) => response.json())
      .then((data) => {
        if (!data.count) return;

        const cards = this.element.querySelector('.js-featured-cards');
        const heading = this.element.querySelector('.js-featured-heading');
        if (cards) cards.innerHTML = data.html;
        if (heading && data.heading) heading.textContent = data.heading;
      })
      .catch(() => {});
  }
}
